import { atom } from 'jotai';

export const onsiteTimerAtom = atom<boolean>(false);
